import {LANG_KEYBOARDS} from "src/consts";
import type {KeyboardsType} from 'entities';
import type {LangType} from 'src/lib/translates/types'
import {DEFAULT_LANG} from 'src/lib/translates/consts'

export const getLetters = (lang?: LangType): KeyboardsType => {
  if (lang) return LANG_KEYBOARDS[lang]

  return LANG_KEYBOARDS[DEFAULT_LANG]
}
